export enum FolderPageNamespace {
  CAMPAIGN_INDEX = 'campaignIndexLastVisitedFolderId',
  TEMPLATE_INDEX = 'templateIndexLastVisitedFolderId',
  LIST_INDEX = 'listIndexLastVisitedFolderId',
}
